<h1 class="offer-selection-title" translate>T_OFFER_DATA_MANAGEMENT_OPTIONS_MANAGEMENT</h1>
<div>
  <se-tabbar option="content">
    <nav>
      <span *ngFor="let tab of getTabs()" [ngClass]="{'active':tab.active}" (click)="selectTab(tab)" translate>{{tab.title}}</span>
    </nav>
  </se-tabbar>
  <div class="offer-selection-container" *ngIf="isTabActive(1)">
    <app-odm-options-element-list
      [selectedRange]="selectedRange"
      (clickBack)="returnOnOfferSelection()">
    </app-odm-options-element-list>
  </div>
  <div class="offer-selection-container" *ngIf="isTabActive(2)">
    <app-odm-options-component-list
      [selectedRange]="selectedRange"
      (clickBack)="returnOnOfferSelection()">
    </app-odm-options-component-list>
  </div>
</div>
